import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  canonical: string;
  ogImage?: string;
  ogType?: string;
  structuredData?: object | object[];
}

const SEO = ({
  title,
  description,
  canonical,
  ogImage = "/screenshots/dashboard-overview.png",
  ogType = "website",
  structuredData,
}: SEOProps) => {
  const fullTitle = `${title} | Piktable`;
  const fullUrl = `https://piktable.ch${canonical}`;

  const structuredDataItems = structuredData
    ? Array.isArray(structuredData) ? structuredData : [structuredData]
    : [];

  return (
    <Helmet>
      {/* Title & Description */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      
      {/* Canonical */}
      <link rel="canonical" href={fullUrl} />
      
      {/* Hreflang for French-speaking Switzerland */}
      <link rel="alternate" hrefLang="fr-CH" href={fullUrl} />
      <link rel="alternate" hrefLang="fr" href={fullUrl} />
      <link rel="alternate" hrefLang="x-default" href={fullUrl} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={`https://piktable.ch${ogImage}`} />
      <meta property="og:locale" content="fr_CH" />
      <meta property="og:site_name" content="Piktable" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`https://piktable.ch${ogImage}`} />
      
      {/* Structured Data */}
      {structuredDataItems.map((data, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(data)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
